/*
  Adventskiste Bundle Guard

  Eine Adventskiste enthaelt genau 24 Produkte. Wer eine Position loescht
  oder die Menge erhoeht, darf nicht auschecken koennen.

  Laeuft auf JEDER Seite, nicht nur im Warenkorb: der Cart Drawer
  (cart_type = drawer) hat einen eigenen Checkout-Button und liegt
  ueberall. Ohne das liesse sich die Regel ueber den Drawer umgehen.

  Quelle der Wahrheit ist immer ein in Liquid gezaehlter Wert, weil nur
  Liquid die Produkt-Tags sieht (finished-kit); /cart.js liefert keine
  Tags. Es gibt zwei solche Marker, beide werden bei Aenderungen von
  Shopifys Section Rendering API frisch gerendert:

    #ak-cart-count    - Warenkorb-Seite (in .js-contents von ak-cart-notice)
    #ak-drawer-count  - Drawer (in .drawer__inner), auf jeder Seite

  Der Zaehler im Header ist BEWUSST keine Quelle: auf der Builder-Seite
  zeigt er die noch nicht bestellte Auswahl an, nicht den Warenkorb.

  VERSAND FUER WEITERE KISTEN (25.10.2026)
  Shopify verrechnet den Versand einmal pro Bestellung. Fuer jede weitere
  Kiste muss die Position "Geschenkbox, Saeckchen & Versand - weitere
  Kiste" im Warenkorb liegen. Soll und Ist rechnet Liquid
  (snippets/ak-versand-zusatz.liquid, Marker #ak-cart-zusatz bzw.
  #ak-drawer-zusatz). Weichen sie ab, setzt syncZusatz() die Menge und
  laedt die Seite neu; bis dahin ist die Kasse gesperrt.
*/
(function () {
  'use strict';

  var CHECKOUT_SELECTOR = '[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout';
  var EXPRESS_SELECTOR = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons';

  function readState() {
    /* Warenkorb-Seite hat Vorrang; sonst der Drawer. */
    var el = document.getElementById('ak-cart-count') || document.getElementById('ak-drawer-count');
    if (!el) return null;
    var count = parseInt(el.getAttribute('data-count'), 10);
    var required = parseInt(el.getAttribute('data-required'), 10);
    if (isNaN(count) || isNaN(required)) return null;
    return { count: count, required: required };
  }

  function readZusatz() {
    var el = document.getElementById('ak-cart-zusatz') || document.getElementById('ak-drawer-zusatz');
    if (!el) return null;
    var have = parseInt(el.getAttribute('data-have'), 10);
    var want = parseInt(el.getAttribute('data-want'), 10);
    var variant = parseInt(el.getAttribute('data-variant'), 10);
    /* Ohne Produkt (geloescht, ausverkauft) nichts sperren - sonst
       kaeme niemand mehr zur Kasse. */
    if (isNaN(have) || isNaN(want) || isNaN(variant)) return null;
    return { have: have, want: want, variant: variant };
  }

  function zusatzOffen() {
    var z = readZusatz();
    return !!z && z.have !== z.want;
  }

  /* Gesperrt, wenn Einzelprodukte im Warenkorb sind und es nicht genau
     24 sind - ein Warenkorb mit ausschliesslich fertigen Kisten zaehlt 0
     und darf ganz normal zur Kasse. Ausserdem, solange die
     Versand-Position fuer weitere Kisten nicht stimmt. */
  function isBlocked(state) {
    return (state.count > 0 && state.count !== state.required) || zusatzOffen();
  }

  /* Menge der Versand-Position angleichen. Danach Neuladen: so rechnen
     Warenkorb, Drawer und Header-Zaehler garantiert mit dem neuen Stand,
     ohne die Section-Rendering-Logik von Dawn nachzubauen.
     Schleifenschutz: vor dem Neuladen merkt sich die Seite, welche
     Korrektur sie gerade angestossen hat (Ist>Soll). Steht nach dem
     Neuladen GENAU dieselbe Abweichung noch da, hat die Korrektur nicht
     gegriffen - dann kein zweiter Versuch, die Kasse bleibt gesperrt.
     Stimmt der Warenkorb, wird die Markierung geloescht.
     Bis 25.10. abends war das eine Zeitsperre von 15 Sekunden fuer JEDE
     Korrektur: wer erhoehte und gleich wieder senkte, blieb auf der
     alten Versandzeile sitzen, vor einer grauen Kasse (von Harry
     gefunden). Eine Zeitsperre kann Benutzer und Schleife nicht
     unterscheiden, das Neuladen schon: nur die Schleife laedt neu,
     ohne dass jemand etwas angeklickt hat. */
  var SYNC_KEY = 'ak_zusatz_sync';
  var syncing = false;
  function syncZusatz() {
    var z = readZusatz();
    if (!z || syncing) return;
    var sig = z.have + '>' + z.want;
    var flag = null;
    try { flag = sessionStorage.getItem(SYNC_KEY); } catch (e) {}
    if (z.have === z.want) {
      if (flag) { try { sessionStorage.removeItem(SYNC_KEY); } catch (e) {} }
      return;
    }
    if (flag === sig) return;
    syncing = true;
    var updates = {};
    updates[z.variant] = z.want;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update ' + r.status);
        try { sessionStorage.setItem(SYNC_KEY, sig); } catch (e) {}
        window.location.reload();
      })
      .catch(function () { syncing = false; });
  }

  function apply() {
    syncZusatz();
    var state = readState();
    if (!state) return;
    var blocked = isBlocked(state);
    var hint = zusatzOffen()
      ? 'Der Versand für weitere Kisten wird ergänzt …'
      : 'Eine Adventskiste enthält genau ' + state.required + ' Produkte.';

    Array.prototype.forEach.call(document.querySelectorAll(CHECKOUT_SELECTOR), function (btn) {
      btn.disabled = blocked;
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      btn.classList.toggle('ak-checkout-blocked', blocked);
      if (blocked) btn.setAttribute('title', hint);
      else btn.removeAttribute('title');
    });

    /* Express-Checkout (Shop Pay, PayPal, Apple Pay) umgeht das
       Warenkorb-Formular komplett - hier hilft nur ausblenden. */
    Array.prototype.forEach.call(document.querySelectorAll(EXPRESS_SELECTOR), function (el) {
      el.style.display = blocked ? 'none' : '';
      el.setAttribute('aria-hidden', blocked ? 'true' : 'false');
    });
  }

  /* Letzte Instanz: selbst wenn irgendetwas den Button wieder aktiviert
     (App, Theme-Editor, Race beim Neurendern), wird hier abgefangen. */
  function intercept(event) {
    var state = readState();
    if (!state || !isBlocked(state)) return;

    var target = event.target;
    var hit = null;
    if (event.type === 'submit') {
      hit = target && target.matches && target.matches('form[action*="/cart"]') ? target : null;
    } else if (target && target.closest) {
      hit = target.closest(CHECKOUT_SELECTOR);
    }
    if (!hit) return;

    event.preventDefault();
    event.stopPropagation();

    /* Auf der Warenkorb-Seite zum Hinweis scrollen. Im Drawer steht der
       Hinweis nicht, deshalb dort eine kurze Meldung. */
    if (zusatzOffen() && !(state.count > 0 && state.count !== state.required)) {
      /* Nur die Versand-Position fehlt: neu anstossen statt Meldung. */
      try { sessionStorage.removeItem(SYNC_KEY); } catch (e) {}
      syncZusatz();
      return;
    }

    var notice = document.getElementById('ak-cart-notice');
    if (notice && document.getElementById('ak-cart-count')) {
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      var left = state.required - state.count;
      alert(
        left > 0
          ? 'Es fehlen noch ' + left + ' Produkte auf ' + state.required + '.'
          : 'Es sind ' + (state.count - state.required) + ' Produkte zu viel im Warenkorb.'
      );
    }
  }

  function init() {
    apply();

    /* Capture-Phase, damit wir vor Dawns eigenen Handlern dran sind. */
    document.addEventListener('click', intercept, true);
    document.addEventListener('submit', intercept, true);

    /* Dawn meldet jede Warenkorb-Aenderung ueber pubsub. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(apply, 0);
      });
    }

    /* Fallback: Footer und Drawer werden bei jeder Aenderung neu
       gerendert und verlieren dabei das gesetzte disabled. Nur
       childList/subtree beobachten - sonst wuerde das disabled-Attribut,
       das wir selbst setzen, den Observer erneut ausloesen. */
    if (window.MutationObserver) {
      ['main-cart-footer', 'CartDrawer'].forEach(function (id) {
        var node = document.getElementById(id);
        if (!node) return;
        new MutationObserver(function () { apply(); })
          .observe(node, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
